import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

// デバイス棚卸しパッケージ集約詳細画面
import { HStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { useInstancesDetail } from '@/routes/_staff/it-operation-core/_root/packages/-components/DeviceInventoryOperation/query';

import { ErrorDisplay } from './-components/common';
import { DeviceInventoryOperationDetail } from './detail/-components';
import { useProcessedStepsData } from './detail/-hooks';

// 詳細画面ではrequestIdは必須
const searchSchema = z.object({
  patternId: z.string(),
  requestId: z.string(),
});

const parentRoute = getRouteApi('/_staff/it-operation-core/device-inventory');

export const Route = createFileRoute(
  '/_staff/it-operation-core/device-inventory/detail',
)({
  validateSearch: zodValidator(searchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const { patternId, requestId } = Route.useSearch();
  const { packageInfo, patternInfo } = parentRoute.useLoaderData();

  const { data, isPending, error } = useInstancesDetail(patternId, {
    requestId,
  });

  // データ処理ロジックを分離
  const processedData = useProcessedStepsData({
    instanceDetails: data?.instanceDetails || [],
    taskProgress: data?.taskProgress ?? {
      total: 0,
      completed: 0,
      inProgress: 0,
      pending: 0,
      percentage: 0,
    },
  });

  const { allSteps, selfReportProgress } = processedData;

  if (isPending) {
    return <ViewportLoader className="w-full" />;
  }

  if (error || !data) {
    return <ErrorDisplay />;
  }

  return (
    <HStack className="px-12 py-7 justify-start items-start gap-9">
      <DeviceInventoryOperationDetail
        packageInfo={packageInfo}
        patternInfo={patternInfo}
        requestId={requestId}
        steps={allSteps}
        patternId={patternId}
        selfReportProgress={selfReportProgress}
      />
    </HStack>
  );
}
